// 系列会社 Select ブロック（「グループ会社・系列会社構造」PJ Ph.4b）
// ------------------------------------------------------------------
// 組織レポート 6 画面（PDF30010 / PDF10010Company / PDF70010 / PDF80010 / Excel30010 / Excel30010Compare）で共用。
// 系列会社ありグループ（selGroupInfo.has_affiliates === true）のときだけ各画面が描画する
// （系列会社なしグループでは本ブロック自体を描画しない＝画面は従来と同一）。
// 選択肢 = 会社名ルール（GET /api/group/:code/company-list）の names + 「全社（グループ全体）」（value ''）。
import React from 'react';
import { Select, Typography } from 'antd';
import { companySelectOptions } from '../../../utils/companyDeptSource';

const { Text } = Typography;

/**
 * @param {Object} props
 * @param {string[]} props.names 系列会社名
 * @param {boolean} [props.allowAll=true] 「全社（グループ全体）」を選べるか（role 7 の会社制限時は false）
 * @param {string} props.value 選択中の系列会社（'' = 全社）
 * @param {Function} props.onChange 選択変更
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.loading]
 */
const CompanySelectBlock = ({ names, allowAll = true, value, onChange, disabled, loading }) => (
  <div style={{ marginTop: 'var(--space-6)', marginBottom: 'var(--space-6)' }}>
    <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>
      系列会社を選択してください。
    </Text>
    <Select
      style={{ width: '100%', maxWidth: 400 }}
      placeholder="系列会社選択"
      options={companySelectOptions(names, { allowAll })}
      value={value}
      onChange={onChange}
      disabled={disabled}
      loading={loading}
    />
    <Text type="secondary" style={{ display: 'block', marginTop: 'var(--space-2)' }}>
      {allowAll
        ? '選択した系列会社の対象者だけで集計します。「全社（グループ全体）」はすべての系列会社が対象です。'
        : '割り当てられた系列会社の対象者だけで集計します。'}
    </Text>
  </div>
);

export default CompanySelectBlock;
